/* eslint-disable max-lines-per-function */
/* eslint-disable max-lines */
import { ChainId } from './util/chains';
import { AuctionContractAbiETHMainnet, AuctioneerEventContractAbiETHMainnet, BaseMarketContractAbiETHMainnet, BulletContractAbiETHMainnet, ContextUpgradeableContractAbiETHMainnet, ContractGeneratorContractAbiETHMainnet, DOBContractAbiETHMainnet, DOBInterfaceContractAbiETHMainnet, DOBStakingPoolContractAbiETHMainnet, DistributionsContractAbiETHMainnet, ERC165ContractAbiETHMainnet, ERC20ContractAbiETHMainnet, ERC20MockContractAbiETHMainnet, ERC20MockDecimals6AbiETHMainnet, ERC20MockDecimals8AbiETHMainnet, ERC20UpgradeableAbiETHMainnet, ERC20WrapperContractAbiETHMainnet, ERC2981AbiETHMainnet, ERC721AAbiETHMainnet, ERC721A__IERC721ReceiverAbiETHMainnet, ERC721ContractAbiETHMainnet, ERC721EnumerableAbiETHMainnet, ERC721MockContractAbiETHMainnet, ERC721URIStorageContractAbiETHMainnet, EventBaseMarketContractAbiETHMainnet, GoldGeregeContractAbiETHMainnet, GovernanceControlContractAbiETHMainnet, GovernorAlphaInterfaceContractAbiETHMainnet, GovernorBravoDelegateContractAbiETHMainnet, GovernorBravoDelegateStorageV1ContractAbiETHMainnet, GovernorBravoDelegateStorageV2ContractAbiETHMainnet, GovernorBravoDelegatorContractAbiETHMainnet, GovernorBravoDelegatorStorageContractAbiETHMainnet, GovernorBravoEventsContractAbiETHMainnet, HODLTokenContractAbiETHMainnet, IBulletContractAbiETHMainnet, IContractGeneratorContractAbiETHMainnet, IDOBStakingPoolContractAbiETHMainnet, IDistributionsContractAbiETHMainnet, IERC165ContractAbiETHMainnet, IERC20ContractAbiETHMainnet, IERC20MetadataContractAbiETHMainnet, IERC20MetadataUpgradeableAbiETHMainnet, IERC20PermitUpgradeableAbiETHMainnet, IERC20UpgradeableContractAbiETHMainnet, IERC2981AbiETHMainnet, IERC721AAbiETHMainnet, IERC721ContractAbiETHMainnet, IERC721EnumerableAbiETHMainnet, IERC721MetadataContractAbiETHMainnet, IERC721ReceiverContractAbiETHMainnet, IGovernanceContractAbiETHMainnet, IOptionContractAbiETHMainnet, IOptionFactoryContractAbiETHMainnet, IOptionTokenContractAbiETHMainnet, ISniperContractAbiETHMainnet, IStakingPoolRewarderContractAbiETHMainnet, IStakingPoolsContractAbiETHMainnet, ITokenFactoryContractAbiETHMainnet, ITokenKeeperAbiETHMainnet, IUniswapv3PoolContractAbiETHMainnet, InitializableContractAbiETHMainnet, MatchingEventsContractAbiETHMainnet, MatchingMarketContractAbiETHMainnet, MockV3AggregatorContractAbiETHMainnet, OptionContractAbiETHMainnet, OptionFactoryContractAbiETHMainnet, OptionTokenContractAbiETHMainnet, OwnableContractAbiETHMainnet, OwnableUpgradeableContractAbiETHMainnet, PausableUpgradeableContractAbiETHMainnet, ReentrancyGuardUpgradeableAbiETHMainnet, SilverGeregeContractAbiETHMainnet, SniperContractAbiETHMainnet, StakingPoolRewarderContractAbiETHMainnet, StakingPoolsContractAbiETHMainnet, TimelockContractAbiETHMainnet, TimelockInterfaceContractAbiETHMainnet, TokenFactoryContractAbiETHMainnet, TokenKeeperAbiETHMainnet, TreasuryContractAbiETHMainnet, WETHContractAbiETHMainnet, } from './eth-mainnet/abi';
import { AuctionContractAbiEthSepolia, AuctioneerEventContractAbiEthSepolia, BaseMarketContractAbiEthSepolia, BulletContractAbiEthSepolia, ContextUpgradeableContractAbiEthSepolia, ContractGeneratorContractAbiEthSepolia, DOBContractAbiEthSepolia, DOBInterfaceContractAbiEthSepolia, DOBStakingPoolContractAbiEthSepolia, DistributionsContractAbiEthSepolia, ERC165ContractAbiEthSepolia, ERC20ContractAbiEthSepolia, ERC20MockContractAbiEthSepolia, ERC20MockDecimals6AbiEthSepolia, ERC20MockDecimals8AbiEthSepolia, ERC20UpgradeableAbiEthSepolia, ERC20WrapperContractAbiEthSepolia, ERC2981AbiEthSepolia, ERC721AAbiEthSepolia, ERC721A__IERC721ReceiverAbiEthSepolia, ERC721ContractAbiEthSepolia, ERC721EnumerableAbiEthSepolia, ERC721MockContractAbiEthSepolia, ERC721URIStorageContractAbiEthSepolia, EventBaseMarketContractAbiEthSepolia, GoldGeregeContractAbiEthSepolia, GovernanceControlContractAbiEthSepolia, GovernorAlphaInterfaceContractAbiEthSepolia, GovernorBravoDelegateContractAbiEthSepolia, GovernorBravoDelegateStorageV1ContractAbiEthSepolia, GovernorBravoDelegateStorageV2ContractAbiEthSepolia, GovernorBravoDelegatorContractAbiEthSepolia, GovernorBravoDelegatorStorageContractAbiEthSepolia, GovernorBravoEventsContractAbiEthSepolia, HODLTokenContractAbiEthSepolia, IBulletContractAbiEthSepolia, IContractGeneratorContractAbiEthSepolia, IDOBStakingPoolContractAbiEthSepolia, IDistributionsContractAbiEthSepolia, IERC165ContractAbiEthSepolia, IERC20ContractAbiEthSepolia, IERC20MetadataContractAbiEthSepolia, IERC20MetadataUpgradeableAbiEthSepolia, IERC20PermitUpgradeableAbiEthSepolia, IERC20UpgradeableContractAbiEthSepolia, IERC2981AbiEthSepolia, IERC721AAbiEthSepolia, IERC721ContractAbiEthSepolia, IERC721EnumerableAbiEthSepolia, IERC721MetadataContractAbiEthSepolia, IERC721ReceiverContractAbiEthSepolia, IGovernanceContractAbiEthSepolia, IOptionContractAbiEthSepolia, IOptionFactoryContractAbiEthSepolia, IOptionTokenContractAbiEthSepolia, ISniperContractAbiEthSepolia, IStakingPoolRewarderContractAbiEthSepolia, IStakingPoolsContractAbiEthSepolia, ITokenFactoryContractAbiEthSepolia, ITokenKeeperAbiEthSepolia, IUniswapv3PoolContractAbiEthSepolia, InitializableContractAbiEthSepolia, MatchingEventsContractAbiEthSepolia, MatchingMarketContractAbiEthSepolia, MockV3AggregatorContractAbiEthSepolia, OptionContractAbiEthSepolia, OptionFactoryContractAbiEthSepolia, OptionTokenContractAbiEthSepolia, OwnableContractAbiEthSepolia, OwnableUpgradeableContractAbiEthSepolia, PausableUpgradeableContractAbiEthSepolia, ReentrancyGuardUpgradeableAbiEthSepolia, SilverGeregeContractAbiEthSepolia, SniperContractAbiEthSepolia, StakingPoolRewarderContractAbiEthSepolia, StakingPoolsContractAbiEthSepolia, TestTokenPoolAbiEthSepolia, TimelockContractAbiEthSepolia, TimelockInterfaceContractAbiEthSepolia, TokenFactoryContractAbiEthSepolia, TokenKeeperAbiEthSepolia, TreasuryContractAbiEthSepolia, WETHContractAbiEthSepolia, } from './eth-sepolia/abi';
import { AuctionContractAbiScrollSepolia, AuctioneerEventContractAbiScrollSepolia, BaseMarketContractAbiScrollSepolia, BulletContractAbiScrollSepolia, ContextUpgradeableContractAbiScrollSepolia, ContractGeneratorContractAbiScrollSepolia, eDOBContractAbiScrollSepolia, DOBInterfaceContractAbiScrollSepolia, DOBStakingPoolContractAbiScrollSepolia, DistributionsContractAbiScrollSepolia, ERC165ContractAbiScrollSepolia, ERC20ContractAbiScrollSepolia, ERC20MockContractAbiScrollSepolia, ERC20MockDecimals6AbiScrollSepolia, ERC20MockDecimals8AbiScrollSepolia, ERC20UpgradeableAbiScrollSepolia, ERC20WrapperContractAbiScrollSepolia, ERC2981AbiScrollSepolia, ERC721AAbiScrollSepolia, ERC721A__IERC721ReceiverAbiScrollSepolia, ERC721ContractAbiScrollSepolia, ERC721EnumerableAbiScrollSepolia, ERC721MockContractAbiScrollSepolia, ERC721URIStorageContractAbiScrollSepolia, EventBaseMarketContractAbiScrollSepolia, GoldGeregeContractAbiScrollSepolia, GovernanceControlContractAbiScrollSepolia, GovernorAlphaInterfaceContractAbiScrollSepolia, GovernorBravoDelegateContractAbiScrollSepolia, GovernorBravoDelegateStorageV1ContractAbiScrollSepolia, GovernorBravoDelegateStorageV2ContractAbiScrollSepolia, GovernorBravoDelegatorContractAbiScrollSepolia, GovernorBravoDelegatorStorageContractAbiScrollSepolia, GovernorBravoEventsContractAbiScrollSepolia, HODLTokenContractAbiScrollSepolia, IBulletContractAbiScrollSepolia, IContractGeneratorContractAbiScrollSepolia, IDOBStakingPoolContractAbiScrollSepolia, IDistributionsContractAbiScrollSepolia, IERC165ContractAbiScrollSepolia, IERC20ContractAbiScrollSepolia, IERC20MetadataContractAbiScrollSepolia, IERC20MetadataUpgradeableAbiScrollSepolia, IERC20PermitUpgradeableAbiScrollSepolia, IERC20UpgradeableContractAbiScrollSepolia, IERC2981AbiScrollSepolia, IERC721AAbiScrollSepolia, IERC721ContractAbiScrollSepolia, IERC721EnumerableAbiScrollSepolia, IERC721MetadataContractAbiScrollSepolia, IERC721ReceiverContractAbiScrollSepolia, IGovernanceContractAbiScrollSepolia, IOptionContractAbiScrollSepolia, IOptionFactoryContractAbiScrollSepolia, IOptionTokenContractAbiScrollSepolia, ISniperContractAbiScrollSepolia, IStakingPoolRewarderContractAbiScrollSepolia, IStakingPoolsContractAbiScrollSepolia, ITokenFactoryContractAbiScrollSepolia, ITokenKeeperAbiScrollSepolia, IUniswapv3PoolContractAbiScrollSepolia, InitializableContractAbiScrollSepolia, MatchingEventsContractAbiScrollSepolia, MatchingMarketContractAbiScrollSepolia, MockV3AggregatorContractAbiScrollSepolia, OptionContractAbiScrollSepolia, OptionFactoryContractAbiScrollSepolia, OptionTokenContractAbiScrollSepolia, OwnableContractAbiScrollSepolia, OwnableUpgradeableContractAbiScrollSepolia, PausableUpgradeableContractAbiScrollSepolia, ReentrancyGuardUpgradeableAbiScrollSepolia, SilverGeregeContractAbiScrollSepolia, SniperContractAbiScrollSepolia, StakingPoolRewarderContractAbiScrollSepolia, StakingPoolsContractAbiScrollSepolia, TestTokenPoolAbiScrollSepolia, TimelockContractAbiScrollSepolia, TimelockInterfaceContractAbiScrollSepolia, TokenFactoryContractAbiScrollSepolia, TokenKeeperAbiScrollSepolia, TreasuryContractAbiScrollSepolia, WETHContractAbiScrollSepolia, } from './scroll-sepolia/abi';
export const SilverGeregeContractAbiEnum = {
    [ChainId.ETH_MAINNET]: SilverGeregeContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: SilverGeregeContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: SilverGeregeContractAbiScrollSepolia,
};
export const ERC20ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC20ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC20ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC20ContractAbiScrollSepolia,
};
export const WETHContractAbiEnum = {
    [ChainId.ETH_MAINNET]: WETHContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: WETHContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: WETHContractAbiScrollSepolia,
};
export const AuctionContractAbiEnum = {
    [ChainId.ETH_MAINNET]: AuctionContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: AuctionContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: AuctionContractAbiScrollSepolia,
};
export const AuctioneerEventContractAbiEnum = {
    [ChainId.ETH_MAINNET]: AuctioneerEventContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: AuctioneerEventContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: AuctioneerEventContractAbiScrollSepolia,
};
export const BaseMarketContractAbiEnum = {
    [ChainId.ETH_MAINNET]: BaseMarketContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: BaseMarketContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: BaseMarketContractAbiScrollSepolia,
};
export const BulletContractAbiEnum = {
    [ChainId.ETH_MAINNET]: BulletContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: BulletContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: BulletContractAbiScrollSepolia,
};
export const ContextUpgradeableContracttAbiEnum = {
    [ChainId.ETH_MAINNET]: ContextUpgradeableContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ContextUpgradeableContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ContextUpgradeableContractAbiScrollSepolia,
};
export const ContractGeneratorContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ContractGeneratorContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ContractGeneratorContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ContractGeneratorContractAbiScrollSepolia,
};
export const DOBContractAbiEnum = {
    [ChainId.ETH_MAINNET]: DOBContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: DOBContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: eDOBContractAbiScrollSepolia,
};
export const DOBInterfaceContractAbiEnum = {
    [ChainId.ETH_MAINNET]: DOBInterfaceContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: DOBInterfaceContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: DOBInterfaceContractAbiScrollSepolia,
};
export const DOBStakingPoolContractAbiEnum = {
    [ChainId.ETH_MAINNET]: DOBStakingPoolContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: DOBStakingPoolContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: DOBStakingPoolContractAbiScrollSepolia,
};
export const DistributionsContractAbiEnum = {
    [ChainId.ETH_MAINNET]: DistributionsContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: DistributionsContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: DistributionsContractAbiScrollSepolia,
};
export const ERC165ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC165ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC165ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC165ContractAbiScrollSepolia,
};
export const ERC20MockContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC20MockContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC20MockContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC20MockContractAbiScrollSepolia,
};
export const ERC20MockDecimals6AbiEnum = {
    [ChainId.ETH_MAINNET]: ERC20MockDecimals6AbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC20MockDecimals6AbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC20MockDecimals6AbiScrollSepolia,
};
export const ERC20MockDecimals8AbiEnum = {
    [ChainId.ETH_MAINNET]: ERC20MockDecimals8AbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC20MockDecimals8AbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC20MockDecimals8AbiScrollSepolia,
};
export const ERC20UpgradeableAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC20UpgradeableAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC20UpgradeableAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC20UpgradeableAbiScrollSepolia,
};
export const ERC20WrapperContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC20WrapperContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC20WrapperContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC20WrapperContractAbiScrollSepolia,
};
export const ERC2981AbiEnum = {
    [ChainId.ETH_MAINNET]: ERC2981AbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC2981AbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC2981AbiScrollSepolia,
};
export const ERC721ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC721ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC721ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC721ContractAbiScrollSepolia,
};
export const ERC721AAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC721AAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC721AAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC721AAbiScrollSepolia,
};
export const ERC721A__IERC721ReceiverAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC721A__IERC721ReceiverAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC721A__IERC721ReceiverAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC721A__IERC721ReceiverAbiScrollSepolia,
};
export const ERC721EnumerableAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC721EnumerableAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC721EnumerableAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC721EnumerableAbiScrollSepolia,
};
export const ERC721MockContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC721MockContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC721MockContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC721MockContractAbiScrollSepolia,
};
export const ERC721URIStorageContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ERC721URIStorageContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ERC721URIStorageContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ERC721URIStorageContractAbiScrollSepolia,
};
export const EventBaseMarketContractAbiEnum = {
    [ChainId.ETH_MAINNET]: EventBaseMarketContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: EventBaseMarketContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: EventBaseMarketContractAbiScrollSepolia,
};
export const GoldGeregeContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GoldGeregeContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GoldGeregeContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GoldGeregeContractAbiScrollSepolia,
};
export const GovernanceControlContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernanceControlContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernanceControlContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernanceControlContractAbiScrollSepolia,
};
export const GovernorAlphaInterfaceContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorAlphaInterfaceContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorAlphaInterfaceContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorAlphaInterfaceContractAbiScrollSepolia,
};
export const GovernorBravoDelegateContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorBravoDelegateContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorBravoDelegateContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorBravoDelegateContractAbiScrollSepolia,
};
export const GovernorBravoDelegateStorageV1ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorBravoDelegateStorageV1ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorBravoDelegateStorageV1ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorBravoDelegateStorageV1ContractAbiScrollSepolia,
};
export const GovernorBravoDelegateStorageV2ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorBravoDelegateStorageV2ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorBravoDelegateStorageV2ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorBravoDelegateStorageV2ContractAbiScrollSepolia,
};
export const GovernorBravoDelegatorContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorBravoDelegatorContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorBravoDelegatorContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorBravoDelegatorContractAbiScrollSepolia,
};
export const GovernorBravoDelegatorStorageContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorBravoDelegatorStorageContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorBravoDelegatorStorageContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorBravoDelegatorStorageContractAbiScrollSepolia,
};
export const GovernorBravoEventsContractAbiEnum = {
    [ChainId.ETH_MAINNET]: GovernorBravoEventsContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: GovernorBravoEventsContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: GovernorBravoEventsContractAbiScrollSepolia,
};
export const HODLTokenContractAbiEnum = {
    [ChainId.ETH_MAINNET]: HODLTokenContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: HODLTokenContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: HODLTokenContractAbiScrollSepolia,
};
export const IBulletContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IBulletContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IBulletContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IBulletContractAbiScrollSepolia,
};
export const IContractGeneratorContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IContractGeneratorContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IContractGeneratorContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IContractGeneratorContractAbiScrollSepolia,
};
export const IDOBStakingPoolContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IDOBStakingPoolContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IDOBStakingPoolContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IDOBStakingPoolContractAbiScrollSepolia,
};
export const IDistributionsContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IDistributionsContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IDistributionsContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IDistributionsContractAbiScrollSepolia,
};
export const IERC165ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC165ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC165ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC165ContractAbiScrollSepolia,
};
export const IERC20ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC20ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC20ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC20ContractAbiScrollSepolia,
};
export const IERC20MetadataContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC20MetadataContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC20MetadataContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC20MetadataContractAbiScrollSepolia,
};
export const IERC20MetadataUpgradeableAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC20MetadataUpgradeableAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC20MetadataUpgradeableAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC20MetadataUpgradeableAbiScrollSepolia,
};
export const IERC20PermitUpgradeableAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC20PermitUpgradeableAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC20PermitUpgradeableAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC20PermitUpgradeableAbiScrollSepolia,
};
export const IERC20UpgradeableContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC20UpgradeableContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC20UpgradeableContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC20UpgradeableContractAbiScrollSepolia,
};
export const IERC2981AbiEnum = {
    [ChainId.ETH_MAINNET]: IERC2981AbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC2981AbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC2981AbiScrollSepolia,
};
export const IERC721ContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC721ContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC721ContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC721ContractAbiScrollSepolia,
};
export const IERC721AAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC721AAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC721AAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC721AAbiScrollSepolia,
};
export const IERC721EnumerableAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC721EnumerableAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC721EnumerableAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC721EnumerableAbiScrollSepolia,
};
export const IERC721MetadataContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC721MetadataContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC721MetadataContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC721MetadataContractAbiScrollSepolia,
};
export const IERC721ReceiverContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IERC721ReceiverContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IERC721ReceiverContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IERC721ReceiverContractAbiScrollSepolia,
};
export const IGovernanceContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IGovernanceContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IGovernanceContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IGovernanceContractAbiScrollSepolia,
};
export const IOptionContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IOptionContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IOptionContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IOptionContractAbiScrollSepolia,
};
export const IOptionFactoryContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IOptionFactoryContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IOptionFactoryContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IOptionFactoryContractAbiScrollSepolia,
};
export const IOptionTokenContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IOptionTokenContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IOptionTokenContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IOptionTokenContractAbiScrollSepolia,
};
export const ISniperContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ISniperContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ISniperContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ISniperContractAbiScrollSepolia,
};
export const IStakingPoolRewarderContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IStakingPoolRewarderContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IStakingPoolRewarderContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IStakingPoolRewarderContractAbiScrollSepolia,
};
export const IStakingPoolsContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IStakingPoolsContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IStakingPoolsContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IStakingPoolsContractAbiScrollSepolia,
};
export const ITokenFactoryContractAbiEnum = {
    [ChainId.ETH_MAINNET]: ITokenFactoryContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ITokenFactoryContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ITokenFactoryContractAbiScrollSepolia,
};
export const ITokenKeeperAbiEnum = {
    [ChainId.ETH_MAINNET]: ITokenKeeperAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ITokenKeeperAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ITokenKeeperAbiScrollSepolia,
};
export const IUniswapv3PoolContractAbiEnum = {
    [ChainId.ETH_MAINNET]: IUniswapv3PoolContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: IUniswapv3PoolContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: IUniswapv3PoolContractAbiScrollSepolia,
};
export const InitializableContractAbiEnum = {
    [ChainId.ETH_MAINNET]: InitializableContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: InitializableContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: InitializableContractAbiScrollSepolia,
};
export const MatchingEventsContractAbiEnum = {
    [ChainId.ETH_MAINNET]: MatchingEventsContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: MatchingEventsContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: MatchingEventsContractAbiScrollSepolia,
};
export const MatchingMarketContractAbiEnum = {
    [ChainId.ETH_MAINNET]: MatchingMarketContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: MatchingMarketContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: MatchingMarketContractAbiScrollSepolia,
};
export const MockV3AggregatorContractAbiEnum = {
    [ChainId.ETH_MAINNET]: MockV3AggregatorContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: MockV3AggregatorContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: MockV3AggregatorContractAbiScrollSepolia,
};
export const OptionTokenContractAbiEnum = {
    [ChainId.ETH_MAINNET]: OptionTokenContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: OptionTokenContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: OptionTokenContractAbiScrollSepolia,
};
export const OwnableContractAbiEnum = {
    [ChainId.ETH_MAINNET]: OwnableContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: OwnableContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: OwnableContractAbiScrollSepolia,
};
export const OwnableUpgradeableContractAbiEnum = {
    [ChainId.ETH_MAINNET]: OwnableUpgradeableContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: OwnableUpgradeableContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: OwnableUpgradeableContractAbiScrollSepolia,
};
export const PausableUpgradeableContractAbiEnum = {
    [ChainId.ETH_MAINNET]: PausableUpgradeableContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: PausableUpgradeableContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: PausableUpgradeableContractAbiScrollSepolia,
};
export const ReentrancyGuardUpgradeableAbiEnum = {
    [ChainId.ETH_MAINNET]: ReentrancyGuardUpgradeableAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: ReentrancyGuardUpgradeableAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: ReentrancyGuardUpgradeableAbiScrollSepolia,
};
export const SniperContractAbiEnum = {
    [ChainId.ETH_MAINNET]: SniperContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: SniperContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: SniperContractAbiScrollSepolia,
};
export const StakingPoolRewarderContractAbiEnum = {
    [ChainId.ETH_MAINNET]: StakingPoolRewarderContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: StakingPoolRewarderContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: StakingPoolRewarderContractAbiScrollSepolia,
};
export const StakingPoolsContractAbiEnum = {
    [ChainId.ETH_MAINNET]: StakingPoolsContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: StakingPoolsContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: StakingPoolsContractAbiScrollSepolia,
};
export const TestTokenPoolContractAbiEnum = {
    [ChainId.ETH_MAINNET]: [],
    [ChainId.ETH_SEPOLIA]: TestTokenPoolAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TestTokenPoolAbiScrollSepolia,
};
export const TimelockContractAbiEnum = {
    [ChainId.ETH_MAINNET]: TimelockContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: TimelockContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TimelockContractAbiScrollSepolia,
};
export const TimelockInterfaceContractAbiEnum = {
    [ChainId.ETH_MAINNET]: TimelockInterfaceContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: TimelockInterfaceContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TimelockInterfaceContractAbiScrollSepolia,
};
export const TokenFactoryContractAbiEnum = {
    [ChainId.ETH_MAINNET]: TokenFactoryContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: TokenFactoryContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TokenFactoryContractAbiScrollSepolia,
};
export const TokenKeeperAbiEnum = {
    [ChainId.ETH_MAINNET]: TokenKeeperAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: TokenKeeperAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TokenKeeperAbiScrollSepolia,
};
export const TreasuryContractAbiEnum = {
    [ChainId.ETH_MAINNET]: TreasuryContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: TreasuryContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: TreasuryContractAbiScrollSepolia,
};
export const OptionContractAbiEnum = {
    [ChainId.ETH_MAINNET]: OptionContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: OptionContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: OptionContractAbiScrollSepolia,
};
export const OptionFactoryContractAbiEnum = {
    [ChainId.ETH_MAINNET]: OptionFactoryContractAbiETHMainnet,
    [ChainId.ETH_SEPOLIA]: OptionFactoryContractAbiEthSepolia,
    [ChainId.SCROLL_SEPOLIA]: OptionFactoryContractAbiScrollSepolia,
};
export let SilverGeregeContractAbi = SilverGeregeContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC20ContractAbi = ERC20ContractAbiEnum[ChainId.ETH_MAINNET];
export let WETHContractAbi = WETHContractAbiEnum[ChainId.ETH_MAINNET];
export let AuctionContractAbi = AuctionContractAbiEnum[ChainId.ETH_MAINNET];
export let AuctioneerEventContractAbi = AuctioneerEventContractAbiEnum[ChainId.ETH_MAINNET];
export let BaseMarketContractAbi = BaseMarketContractAbiEnum[ChainId.ETH_MAINNET];
export let BulletContractAbi = BulletContractAbiEnum[ChainId.ETH_MAINNET];
export let ContextUpgradeableContracttAbi = ContextUpgradeableContracttAbiEnum[ChainId.ETH_MAINNET];
export let ContractGeneratorContractAbi = ContractGeneratorContractAbiEnum[ChainId.ETH_MAINNET];
export let DOBContractAbi = DOBContractAbiEnum[ChainId.ETH_MAINNET];
export let DOBInterfaceContractAbi = DOBInterfaceContractAbiEnum[ChainId.ETH_MAINNET];
export let DOBStakingPoolContractAbi = DOBStakingPoolContractAbiEnum[ChainId.ETH_MAINNET];
export let DistributionsContractAbi = DistributionsContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC165ContractAbi = ERC165ContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC20MockContractAbi = ERC20MockContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC20MockDecimals6Abi = ERC20MockDecimals6AbiEnum[ChainId.ETH_MAINNET];
export let ERC20MockDecimals8Abi = ERC20MockDecimals8AbiEnum[ChainId.ETH_MAINNET];
export let ERC20UpgradeableAbi = ERC20UpgradeableAbiEnum[ChainId.ETH_MAINNET];
export let ERC20WrapperContractAbi = ERC20WrapperContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC2981Abi = ERC2981AbiEnum[ChainId.ETH_MAINNET];
export let ERC721ContractAbi = ERC721ContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC721AAbi = ERC721AAbiEnum[ChainId.ETH_MAINNET];
export let ERC721A__IERC721ReceiverAbi = ERC721A__IERC721ReceiverAbiEnum[ChainId.ETH_MAINNET];
export let ERC721EnumerableAbi = ERC721EnumerableAbiEnum[ChainId.ETH_MAINNET];
export let ERC721MockContractAbi = ERC721MockContractAbiEnum[ChainId.ETH_MAINNET];
export let ERC721URIStorageContractAbi = ERC721URIStorageContractAbiEnum[ChainId.ETH_MAINNET];
export let EventBaseMarketContractAbi = EventBaseMarketContractAbiEnum[ChainId.ETH_MAINNET];
export let GoldGeregeContractAbi = GoldGeregeContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernanceControlContractAbi = GovernanceControlContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorAlphaInterfaceContractAbi = GovernorAlphaInterfaceContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorBravoDelegateContractAbi = GovernorBravoDelegateContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorBravoDelegateStorageV1ContractAbi = GovernorBravoDelegateStorageV1ContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorBravoDelegateStorageV2ContractAbi = GovernorBravoDelegateStorageV2ContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorBravoDelegatorContractAbi = GovernorBravoDelegatorContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorBravoDelegatorStorageContractAbi = GovernorBravoDelegatorStorageContractAbiEnum[ChainId.ETH_MAINNET];
export let GovernorBravoEventsContractAbi = GovernorBravoEventsContractAbiEnum[ChainId.ETH_MAINNET];
export let HODLTokenContractAbi = HODLTokenContractAbiEnum[ChainId.ETH_MAINNET];
export let IBulletContractAbi = IBulletContractAbiEnum[ChainId.ETH_MAINNET];
export let IContractGeneratorContractAbi = IContractGeneratorContractAbiEnum[ChainId.ETH_MAINNET];
export let IDOBStakingPoolContractAbi = IDOBStakingPoolContractAbiEnum[ChainId.ETH_MAINNET];
export let IDistributionsContractAbi = IDistributionsContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC165ContractAbi = IERC165ContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC20ContractAbi = IERC20ContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC20MetadataContractAbi = IERC20MetadataContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC20MetadataUpgradeableAbi = IERC20MetadataUpgradeableAbiEnum[ChainId.ETH_MAINNET];
export let IERC20PermitUpgradeableAbi = IERC20PermitUpgradeableAbiEnum[ChainId.ETH_MAINNET];
export let IERC20UpgradeableContractAbi = IERC20UpgradeableContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC2981Abi = IERC2981AbiEnum[ChainId.ETH_MAINNET];
export let IERC721ContractAbi = IERC721ContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC721AAbi = IERC721AAbiEnum[ChainId.ETH_MAINNET];
export let IERC721EnumerableAbi = IERC721EnumerableAbiEnum[ChainId.ETH_MAINNET];
export let IERC721MetadataContractAbi = IERC721MetadataContractAbiEnum[ChainId.ETH_MAINNET];
export let IERC721ReceiverContractAbi = IERC721ReceiverContractAbiEnum[ChainId.ETH_MAINNET];
export let IGovernanceContractAbi = IGovernanceContractAbiEnum[ChainId.ETH_MAINNET];
export let IOptionContractAbi = IOptionContractAbiEnum[ChainId.ETH_MAINNET];
export let IOptionFactoryContractAbi = IOptionFactoryContractAbiEnum[ChainId.ETH_MAINNET];
export let IOptionTokenContractAbi = IOptionTokenContractAbiEnum[ChainId.ETH_MAINNET];
export let ISniperContractAbi = ISniperContractAbiEnum[ChainId.ETH_MAINNET];
export let IStakingPoolRewarderContractAbi = IStakingPoolRewarderContractAbiEnum[ChainId.ETH_MAINNET];
export let IStakingPoolsContractAbi = IStakingPoolsContractAbiEnum[ChainId.ETH_MAINNET];
export let ITokenFactoryContractAbi = ITokenFactoryContractAbiEnum[ChainId.ETH_MAINNET];
export let ITokenKeeperAbi = ITokenKeeperAbiEnum[ChainId.ETH_MAINNET];
export let IUniswapv3PoolContractAbi = IUniswapv3PoolContractAbiEnum[ChainId.ETH_MAINNET];
export let InitializableContractAbi = InitializableContractAbiEnum[ChainId.ETH_MAINNET];
export let MatchingEventsContractAbi = MatchingEventsContractAbiEnum[ChainId.ETH_MAINNET];
export let MatchingMarketContractAbi = MatchingMarketContractAbiEnum[ChainId.ETH_MAINNET];
export let MockV3AggregatorContractAbi = MockV3AggregatorContractAbiEnum[ChainId.ETH_MAINNET];
export let OptionTokenContractAbi = OptionTokenContractAbiEnum[ChainId.ETH_MAINNET];
export let OwnableContractAbi = OwnableContractAbiEnum[ChainId.ETH_MAINNET];
export let OwnableUpgradeableContractAbi = OwnableUpgradeableContractAbiEnum[ChainId.ETH_MAINNET];
export let PausableUpgradeableContractAbi = PausableUpgradeableContractAbiEnum[ChainId.ETH_MAINNET];
export let ReentrancyGuardUpgradeableAbi = ReentrancyGuardUpgradeableAbiEnum[ChainId.ETH_MAINNET];
export let SniperContractAbi = SniperContractAbiEnum[ChainId.ETH_MAINNET];
export let StakingPoolRewarderContractAbi = StakingPoolRewarderContractAbiEnum[ChainId.ETH_MAINNET];
export let StakingPoolsContractAbi = StakingPoolsContractAbiEnum[ChainId.ETH_MAINNET];
export let TestTokenPoolContractAbi = TestTokenPoolContractAbiEnum[ChainId.ETH_MAINNET];
export let TimelockContractAbi = TimelockContractAbiEnum[ChainId.ETH_MAINNET];
export let TimelockInterfaceContractAbi = TimelockInterfaceContractAbiEnum[ChainId.ETH_MAINNET];
export let TokenFactoryContractAbi = TokenFactoryContractAbiEnum[ChainId.ETH_MAINNET];
export let TokenKeeperAbi = TokenKeeperAbiEnum[ChainId.ETH_MAINNET];
export let TreasuryContractAbi = TreasuryContractAbiEnum[ChainId.ETH_MAINNET];
export let OptionContractAbi = OptionContractAbiEnum[ChainId.ETH_MAINNET];
export let OptionFactoryContractAbi = OptionFactoryContractAbiEnum[ChainId.ETH_MAINNET];
export const initContractABIs = (chainId) => {
    SilverGeregeContractAbi = SilverGeregeContractAbiEnum[chainId];
    ERC20ContractAbi = ERC20ContractAbiEnum[chainId];
    WETHContractAbi = WETHContractAbiEnum[chainId];
    AuctionContractAbi = AuctionContractAbiEnum[chainId];
    AuctioneerEventContractAbi = AuctioneerEventContractAbiEnum[chainId];
    BaseMarketContractAbi = BaseMarketContractAbiEnum[chainId];
    BulletContractAbi = BulletContractAbiEnum[chainId];
    ContextUpgradeableContracttAbi = ContextUpgradeableContracttAbiEnum[chainId];
    ContractGeneratorContractAbi = ContractGeneratorContractAbiEnum[chainId];
    DOBContractAbi = DOBContractAbiEnum[chainId];
    DOBInterfaceContractAbi = DOBInterfaceContractAbiEnum[chainId];
    DOBStakingPoolContractAbi = DOBStakingPoolContractAbiEnum[chainId];
    DistributionsContractAbi = DistributionsContractAbiEnum[chainId];
    ERC165ContractAbi = ERC165ContractAbiEnum[chainId];
    ERC20MockContractAbi = ERC20MockContractAbiEnum[chainId];
    ERC20MockDecimals6Abi = ERC20MockDecimals6AbiEnum[chainId];
    ERC20MockDecimals8Abi = ERC20MockDecimals8AbiEnum[chainId];
    ERC20UpgradeableAbi = ERC20UpgradeableAbiEnum[chainId];
    ERC20WrapperContractAbi = ERC20WrapperContractAbiEnum[chainId];
    ERC2981Abi = ERC2981AbiEnum[chainId];
    ERC721ContractAbi = ERC721ContractAbiEnum[chainId];
    ERC721AAbi = ERC721AAbiEnum[chainId];
    ERC721A__IERC721ReceiverAbi = ERC721A__IERC721ReceiverAbiEnum[chainId];
    ERC721EnumerableAbi = ERC721EnumerableAbiEnum[chainId];
    ERC721MockContractAbi = ERC721MockContractAbiEnum[chainId];
    ERC721URIStorageContractAbi = ERC721URIStorageContractAbiEnum[chainId];
    EventBaseMarketContractAbi = EventBaseMarketContractAbiEnum[chainId];
    GoldGeregeContractAbi = GoldGeregeContractAbiEnum[chainId];
    GovernanceControlContractAbi = GovernanceControlContractAbiEnum[chainId];
    GovernorAlphaInterfaceContractAbi =
        GovernorAlphaInterfaceContractAbiEnum[chainId];
    GovernorBravoDelegateContractAbi =
        GovernorBravoDelegateContractAbiEnum[chainId];
    GovernorBravoDelegateStorageV1ContractAbi =
        GovernorBravoDelegateStorageV1ContractAbiEnum[chainId];
    GovernorBravoDelegateStorageV2ContractAbi =
        GovernorBravoDelegateStorageV2ContractAbiEnum[chainId];
    GovernorBravoDelegatorContractAbi =
        GovernorBravoDelegatorContractAbiEnum[chainId];
    GovernorBravoDelegatorStorageContractAbi =
        GovernorBravoDelegatorStorageContractAbiEnum[chainId];
    GovernorBravoEventsContractAbi = GovernorBravoEventsContractAbiEnum[chainId];
    HODLTokenContractAbi = HODLTokenContractAbiEnum[chainId];
    IBulletContractAbi = IBulletContractAbiEnum[chainId];
    IContractGeneratorContractAbi = IContractGeneratorContractAbiEnum[chainId];
    IDOBStakingPoolContractAbi = IDOBStakingPoolContractAbiEnum[chainId];
    IDistributionsContractAbi = IDistributionsContractAbiEnum[chainId];
    IERC165ContractAbi = IERC165ContractAbiEnum[chainId];
    IERC20ContractAbi = IERC20ContractAbiEnum[chainId];
    IERC20MetadataContractAbi = IERC20MetadataContractAbiEnum[chainId];
    IERC20MetadataUpgradeableAbi = IERC20MetadataUpgradeableAbiEnum[chainId];
    IERC20PermitUpgradeableAbi = IERC20PermitUpgradeableAbiEnum[chainId];
    IERC20UpgradeableContractAbi = IERC20UpgradeableContractAbiEnum[chainId];
    IERC2981Abi = IERC2981AbiEnum[chainId];
    IERC721ContractAbi = IERC721ContractAbiEnum[chainId];
    IERC721AAbi = IERC721AAbiEnum[chainId];
    IERC721EnumerableAbi = IERC721EnumerableAbiEnum[chainId];
    IERC721MetadataContractAbi = IERC721MetadataContractAbiEnum[chainId];
    IERC721ReceiverContractAbi = IERC721ReceiverContractAbiEnum[chainId];
    IGovernanceContractAbi = IGovernanceContractAbiEnum[chainId];
    IOptionContractAbi = IOptionContractAbiEnum[chainId];
    IOptionFactoryContractAbi = IOptionFactoryContractAbiEnum[chainId];
    IOptionTokenContractAbi = IOptionTokenContractAbiEnum[chainId];
    ISniperContractAbi = ISniperContractAbiEnum[chainId];
    IStakingPoolRewarderContractAbi = IStakingPoolRewarderContractAbiEnum[chainId];
    IStakingPoolsContractAbi = IStakingPoolsContractAbiEnum[chainId];
    ITokenFactoryContractAbi = ITokenFactoryContractAbiEnum[chainId];
    ITokenKeeperAbi = ITokenKeeperAbiEnum[chainId];
    IUniswapv3PoolContractAbi = IUniswapv3PoolContractAbiEnum[chainId];
    InitializableContractAbi = InitializableContractAbiEnum[chainId];
    MatchingEventsContractAbi = MatchingEventsContractAbiEnum[chainId];
    MatchingMarketContractAbi = MatchingMarketContractAbiEnum[chainId];
    MockV3AggregatorContractAbi = MockV3AggregatorContractAbiEnum[chainId];
    OptionTokenContractAbi = OptionTokenContractAbiEnum[chainId];
    OwnableContractAbi = OwnableContractAbiEnum[chainId];
    OwnableUpgradeableContractAbi = OwnableUpgradeableContractAbiEnum[chainId];
    PausableUpgradeableContractAbi = PausableUpgradeableContractAbiEnum[chainId];
    ReentrancyGuardUpgradeableAbi = ReentrancyGuardUpgradeableAbiEnum[chainId];
    SniperContractAbi = SniperContractAbiEnum[chainId];
    StakingPoolRewarderContractAbi = StakingPoolRewarderContractAbiEnum[chainId];
    StakingPoolsContractAbi = StakingPoolsContractAbiEnum[chainId];
    TestTokenPoolContractAbi = TestTokenPoolContractAbiEnum[chainId];
    TimelockContractAbi = TimelockContractAbiEnum[chainId];
    TimelockInterfaceContractAbi = TimelockInterfaceContractAbiEnum[chainId];
    TokenFactoryContractAbi = TokenFactoryContractAbiEnum[chainId];
    TokenKeeperAbi = TokenKeeperAbiEnum[chainId];
    TreasuryContractAbi = TreasuryContractAbiEnum[chainId];
    OptionContractAbi = OptionContractAbiEnum[chainId];
    OptionFactoryContractAbi = OptionFactoryContractAbiEnum[chainId];
};
//# sourceMappingURL=abi.js.map